export default __webpack_public_path__ + "static/c_logo-6c24265654ad3cbbbc55196097f4375d.svg";